import { IS_DEV } from './env-config';

export const REACT_APP_API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const REACT_APP_COGNITO_REGION = process.env.REACT_APP_COGNITO_REGION;
export const REACT_APP_COGNITO_USER_POOL_CLIENT_ID = process.env.REACT_APP_COGNITO_USER_POOL_CLIENT_ID;
export const REACT_APP_COGNITO_USER_POOL_ID = process.env.REACT_APP_COGNITO_USER_POOL_ID;
export const COOKIE_DOMAIN = IS_DEV ? 'localhost' : process.env.REACT_APP_PARENT_URL!.match(/(?<=https:\/\/).*/)![0];
